/**
 * This file with its imports is being loaded in the security.ejs on production using webpack.
 * While working locally, the last bundle is being loaded in the security.ejs as minified + uglyfied code.
 * To see changes from your code locally, after each change you need to build and run "node update-template.js" to update the security.ejs file.
 * This is only because yoshi does let us to remove the loaded webpack-dev-server into the bundle and it causes errors locally only.
 */
import { freezeClientGlobals } from './freezeClientGlobals'
import { hardenOpenWindow } from './overridingGlobals/window'
import { overrideIframe } from './overridingGlobals/iframe'
import { hardenFetchAndXHR } from './overridingGlobals/fetchAndXHR'
import { overrideTimeout } from './overridingGlobals/timeout'
import { removeServiceWorker } from './overridingGlobals/serviceWorker'
import { isExperimentOpen } from '@wix/thunderbolt-experiments'

performance.mark('overrideGlobals started')

// @ts-expect-error
const { experiments } = window.viewerModel

const isSecurityHardeningsEnabled = isExperimentOpen(experiments, 'specs.thunderbolt.securityExperiments')

try {
	// Start override globals
	hardenOpenWindow()

	if (isSecurityHardeningsEnabled) {
		overrideIframe()
	}

	if (isExperimentOpen(experiments, 'specs.thunderbolt.hardenFetchAndXHR') && isSecurityHardeningsEnabled) {
		hardenFetchAndXHR()
	}

	removeServiceWorker()

	freezeClientGlobals(isSecurityHardeningsEnabled)

	if (isSecurityHardeningsEnabled) {
		overrideTimeout()
	}
} catch (e) {
	// @ts-expect-error
	if (window?.viewerModel?.mode.debug) {
		console.error(e)
	}

	const error = new Error('TB006')
	// @ts-expect-error
	window.fedops?.reportError(error, 'security_overrideGlobals')

	// @ts-expect-error
	if (window.Sentry) {
		// @ts-expect-error
		window.Sentry.captureException(error)
	} else {
		// @ts-expect-error
		globalThis.defineStrictProperty('sentryBuffer', [error], window, false)
	}
}

performance.mark('overrideGlobals ended')
